<template>
  <div>
    <h3 class="text-center mb-4 mt-4">密码修改</h3>
    <div class="page-title-desc text-center mb-5 mt-4" v-if="desc">为确保您的账户安全，请选择验证方式</div>
    <div class="page-title-desc text-center mb-5 mt-4" v-if="tooltip">账户<span class="user-name mr-2 ml-2">{{info.name}}</span>为确认是您本人操作，请完成以下验证</div>
    <a-card class="page-card mb-4" hoverable v-if="showCard">
      <a-row type="flex">
        <a-col :span="18">
          <p class="card-content-title">通过 登录密码</p>
          <p class="card-content-desc">请再次输入当前密码，推荐优先此验证方式</p>
        </a-col>
        <a-col :span="6">
          <p class="card-content-action text-center" @click="check('login-password')">验证</p>
        </a-col>
      </a-row>
    </a-card>
    <a-card class="page-card" hoverable v-if="showCard">
      <a-row type="flex">
        <a-col :span="18">
          <p class="card-content-title">通过 手机/邮箱</p>
          <p class="card-content-desc">请确保您的手机/邮箱可以正常接收验证码</p>
        </a-col>
        <a-col :span="6">
          <p class="card-content-action text-center" @click="check('phone-verification-code')">验证</p>
        </a-col>
      </a-row>
    </a-card>
    <component :is="checkMethod" />
    <a-result
      v-if="isSuccess"
      status="success"
      title="修改成功"
      sub-title="请牢记新的登录密码">
      <template #extra>
        <a-button type="link" @click="logOut">
          重新登录
        </a-button>
      </template>
    </a-result>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { mapState } from 'vuex'
import { OW_PATHS } from '../constants/config'
import PhoneVerificationCode from './components/PhoneVerificationCode'
import LoginPassword from './components/LoginPassword'

export default {
  name: 'EditPassword',
  components: {
    PhoneVerificationCode,
    LoginPassword,
  },
  data () {
    return {
      desc: true,
      tooltip: false,
      showCard: true,
      checkMethod: '',
      isSuccess: false,
    }
  },
  computed: {
    ...mapState('auth', {
      info: state => state.info || {},
    }),
  },
  created () {
    this.$bus.$on('editPasswordSuccess', () => {
      this.isSuccess = true
      this.desc = false
      this.tooltip = false
      this.showCard = false
      this.checkMethod = ''
    })
  },
  methods: {
    check (type) {
      this.desc = false
      this.showCard = false
      this.tooltip = true
      this.checkMethod = type
    },
    logOut () {
      Cookies.remove('yunionauth', {
        domain: '.yunion.cn',
      })
      Cookies.remove('yunionauth', {
        domain: '.yunion.io',
      })
      window.location.href = OW_PATHS[window.location.hostname] ? OW_PATHS[window.location.hostname] : OW_PATHS.default
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/styles/less/index';
  .user-name {
    color: @error-color;
  }
  .page-card {
    width: 838px;
    border-radius: 5px;
    margin: 0 auto;
    ::v-deep {
      .ant-card-body {
        height: 133px;
      }
    }
    .card-content-title {
      font-size: 20px;
      font-weight: bold;
    }
    .card-content-action {
      color: #1678ff;
      font-size: 20px;
      line-height: 85px;
      cursor: pointer;
    }
  }
</style>
